export function contentJsonHeader() {
  return { 'Content-Type': 'application/json; charset=utf-8' }
}
